import React, {Component} from "react";
import { Link, withRouter } from "react-router-dom";
import FeatherIcon from 'feather-icons-react';
import axios from "axios";
import Modal from "react-bootstrap/Modal";
import { getModuleUrl } from "../../moduleConfig";
import BrandMark from "../../components/layout/BrandMark";
import ManualSidebarLink from "../../components/layout/ManualSidebarLink";
import { clearAppStoragePreservingTheme } from "../../theme/branding";

class Sidebar extends Component{

  state = {
    countData : 0,
    modal : false,
    isModal : false,
    schoolfeecategories : [],
    table : []
  }

  componentDidMount(){
    this.getSchoolfeecategories();
    this.getData()
  }

  async getSchoolfeecategories(){
    try {
      const response = await axios.get('schoolfeecategories');
      if(response.status === 200)
      {
          this.setState({schoolfeecategories : response.data || []})
      }
    } catch (error) {
      console.error("Impossible de charger les categories de frais scolaires", error);
    }
  }

  isActiveRoute = (path) => {
    return this.props.location.pathname === path;
  }

  isSchoolfeeRoute = () => {
    const currentPath = this.props.location.pathname;
    return currentPath === "/formschoolfee"
      || currentPath === "/accoutingbalances"
      || currentPath === "/schoolfeesall"
      || currentPath === "/schoolfeesmonths"
      || currentPath === "/schoolfees"
      || currentPath.startsWith("/schoolfees/category/");
  }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

  logout = (e) => {
    axios.post('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
    clearAppStoragePreservingTheme();
    window.location.replace(getModuleUrl("compta"))
  }

  async getData(){
    var data = await axios.get('datamigrates');
    if(data.status == 200)
    {
      this.setState({
        countData : data.data.length,
      })
    }
  }

  refresh = () => {
    this.setState({
      modal : true,
      isModal : false
    })
    axios.get('datamigrates/pull').then((response) => {
        this.setState({
          modal : true,
          isModal : true
        })
    }).catch((error) => {
      console.log(error)
    })
    this.refreshsend()
  }

  refreshsend = () => {
    this.setState({
      modal : true,
      isModal : false
    })
    axios.get('datamigrates/push').then((response) => {

        this.setState({
          modal : true,
          isModal : true
        })
    }).catch((error) => {
      console.log(error)
      // this.refresh()
    })
  }

  modal = () =>{
    this.setState({
      modal : false,
      isModal : false
    })
  }


  change = (val) => {
    this.setState({
      table : []
    })
    var table = [];
    table.push(val)
    this.setState({
      table : table
    })
    this.getData()
  }


    render(){
      const schoolfeeCategoryLinks =
        this.state.schoolfeecategories.map((schoolfeecategory) => {
          const categoryPath = "/schoolfees/category/" + schoolfeecategory.id;
          return(
            <Link className={"nav-link p-2 compta-sidebar__sub-link " + (this.isActiveRoute(categoryPath) ? "active" : "")} onClick={() => this.change(categoryPath)} key={schoolfeecategory.id} aria-current="page" to={categoryPath}>
              <FeatherIcon icon="credit-card" size={"16"}></FeatherIcon>
              <span className="ms-2 d-none d-sm-inline">{ schoolfeecategory.category }</span>
            </Link>
          )
        })

        return(

          <div className="col-auto col-md-2 col-xl-2 bg-white p-0 border border-top-0 compta-sidebar-col">
                <div className="sticky-top d-flex flex-column text-white min-vh-100 compta-sidebar">
                    <a href={getModuleUrl("compta")} className="text-white text-decoration-none shadow text-lef font-weight-bold compta-sidebar__brand"  style={{ backgroundColor : "rgb(0, 108, 189)", fontWeight : 700}}>
                        <BrandMark />
                    </a>

                    <ul className="nav nav-pills flex-column mb-sm-auto ms-2 mt-2 compta-sidebar__nav" id="menu">
                    <li className="compta-sidebar__section" aria-hidden="true">Vue generale</li>
                    {
                      this.handleCheck("Afficher comptabilité") == true && (
                        <li className="nav-item">
                          <Link title="Dashboard" className={"nav-link p-2 "+ this.state.table.filter(data => data == "/").map((val) => { return "active" })} onClick={() => this.change("/")} aria-current="page" to={"/"}>
                            <FeatherIcon icon="activity"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Dashboard</span>
                          </Link>
                        </li>
                      )
                    }

                    <li className="compta-sidebar__section" aria-hidden="true">Operations</li>


                    {
                      this.handleCheck("Afficher paiement") == true && (
                        <li className="nav-item compta-sidebar__group-item">
                          <details className="text-dark w-100 compta-sidebar__group" defaultOpen={this.isSchoolfeeRoute()}>
                            <summary className={"nav-link p-2 d-flex align-items-center " + (this.isSchoolfeeRoute() ? "active" : "")}>
                              <FeatherIcon icon="credit-card" size={"16"}></FeatherIcon>
                              <span className="ms-2 d-none d-sm-inline">Frais scolaire</span>
                              <FeatherIcon icon="chevron-down" size={"14"} className="ms-auto d-none d-sm-inline"></FeatherIcon>
                            </summary>
                            <div className="ms-sm-2 compta-sidebar__submenu">

                                <Link className={"nav-link p-2 compta-sidebar__sub-link "+ (this.isActiveRoute("/formschoolfee") ? "active" : "")} onClick={() => this.change("formschoolfee")}  aria-current="page" to={"/formschoolfee"}>
                                  <FeatherIcon icon="aperture" size={"16"}></FeatherIcon>
                                  <span className="ms-2 d-none d-sm-inline">{"Les entrees"}</span>
                                </Link>
                                <Link className={"nav-link p-2 compta-sidebar__sub-link "+ (this.isActiveRoute("/accoutingbalances") ? "active" : "")} onClick={() => this.change("accoutingbalances")}  aria-current="page" to={"/accoutingbalances"}>
                                  <FeatherIcon icon="file-text" size={"16"}></FeatherIcon>
                                  <span className="ms-2 d-none d-sm-inline">{"Mvnts Journaliers"}</span>
                                </Link>
                                <Link className={"nav-link p-2 compta-sidebar__sub-link "+ (this.isActiveRoute("/schoolfeesall") ? "active" : "")} onClick={() => this.change("schoolfeesall")}  aria-current="page" to={"/schoolfeesall"}>
                                  <FeatherIcon icon="folder" size={"16"}></FeatherIcon>
                                  <span className="ms-2 d-none d-sm-inline">{"Recouvrements"}</span>
                                </Link>
                                <Link className={"nav-link p-2 compta-sidebar__sub-link "+ (this.isActiveRoute("/schoolfeesmonths") ? "active" : "")} onClick={() => this.change("schoolfeesmonths")}  aria-current="page" to={"/schoolfeesmonths"}>
                                  <FeatherIcon icon="briefcase" size={"16"}></FeatherIcon>
                                  <span className="ms-2 d-none d-sm-inline">{"Trimestre"}</span>
                                </Link>
                                <Link className={"nav-link p-2 compta-sidebar__sub-link "+ (this.isActiveRoute("/schoolfees") ? "active" : "")} onClick={() => this.change("schoolfees")}  aria-current="page" to={"/schoolfees"}>
                                  <FeatherIcon icon="bookmark" size={"16"}></FeatherIcon>
                                  <span className="ms-2 d-none d-sm-inline">{"Tous paiements"}</span>
                                </Link>
                                  { schoolfeeCategoryLinks }
                                {/* <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "schoolfees/dettes").map((val) => { return "active" })} onClick={() => this.change("schoolfees/dettes")}  aria-current="page" to={"/schoolfees/dettes"}>
                                  <FeatherIcon icon="folder" size={"16"}></FeatherIcon>
                                  <span className="ms-2 d-none d-sm-inline">{"Dettes"}</span>
                                </Link>
                                <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "schoolfees/avances").map((val) => { return "active" })} onClick={() => this.change("schoolfees/avances")}  aria-current="page" to={"/schoolfees/avances"}>
                                  <FeatherIcon icon="briefcase" size={"16"}></FeatherIcon>
                                  <span className="ms-2 d-none d-sm-inline">{"Avances"}</span>
                                </Link> */}
                            </div>
                          </details>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher don") == true && (
                        <li className="nav-item">
                          <Link title="Don" className={"nav-link p-2 "+ this.state.table.filter(data => data == "gifts").map((val) => { return "active" })} onClick={() => this.change("gifts")} aria-current="page" to={"/gifts"}>
                            <FeatherIcon icon="layout"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Don</span>
                          </Link>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher caisse") == true && (
                        <li className="nav-item">
                          <Link title="Caisse" className={"nav-link p-2 "+ this.state.table.filter(data => data == "chartaccounts").map((val) => { return "active" })} onClick={() => this.change("chartaccounts")} aria-current="page" to={"/chartaccounts"}>
                            <FeatherIcon icon="codepen"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Etat financier</span>
                          </Link>
                        </li>
                      )
                    }

                    {
                      this.handleCheck("Afficher livre caisse") == true && (
                        <li className="nav-item">
                          <Link title="livre caisse" className={"nav-link p-2 "+ this.state.table.filter(data => data == "accountingbalances").map((val) => { return "active" })} onClick={() => this.change("accountingbalances")} aria-current="page" to={"/accountingbalances"}>
                            <FeatherIcon icon="codesandbox"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Livre de caisse</span>
                          </Link>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher salaire") == true && (
                        <li className="nav-item">
                          <Link title="Salaire" className={"nav-link p-2 "+ this.state.table.filter(data => data == "wages").map((val) => { return "active" })} onClick={() => this.change("wages")} aria-current="page" to={"/wages"}>
                            <FeatherIcon icon="box"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Fiche de paie</span>
                          </Link>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher depense") == true && (
                        <li className="nav-item">
                          <Link title="Depense" className={"nav-link p-2 "+ this.state.table.filter(data => data == "expenses").map((val) => { return "active" })} onClick={() => this.change("expenses")} aria-current="page" to={"/expenses"}>
                            <FeatherIcon icon="framer"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Depenses</span>
                          </Link>
                        </li>
                      )
                    }

                    <li className="compta-sidebar__section" aria-hidden="true">Configuration</li>


                    {
                      this.handleCheck("Afficher type de paiement") == true && (
                        <li className="nav-item">
                          <Link title="Type paiement" className={"nav-link p-2 "+ this.state.table.filter(data => data == "schoolfeecategories").map((val) => { return "active" })} onClick={() => this.change("schoolfeecategories")} aria-current="page" to={"/schoolfeecategories"}>
                            <FeatherIcon icon="divide"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Type frais scolaire</span>
                          </Link>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher type de salaire") == true && (
                        <li className="nav-item">
                          <Link title="Type salaire" className={"nav-link p-2 "+ this.state.table.filter(data => data == "typesalaries").map((val) => { return "active" })} onClick={() => this.change("typesalaries")} aria-current="page" to={"/typesalaries"}>
                            <FeatherIcon icon="dollar-sign"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Type sortie</span>
                          </Link>
                        </li>
                      )
                    }

                    {
                      this.handleCheck("Afficher livre caisse") == true && (
                        <li className="nav-item d-none">
                          <Link title="Type paiement" className={"nav-link p-2 "+ this.state.table.filter(data => data == "accountingbalances").map((val) => { return "active" })} onClick={() => this.change("accountingbalances")} aria-current="page" to={"/accountingbalances"}>
                            <FeatherIcon icon="folder"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Livre de caisse</span>
                          </Link>
                        </li>
                      )
                    }

                    {/* {
                      this.handleCheck("Ajouter paiement") == true && (
                        <li className="nav-item">
                          <Link className={"nav-link p-2 "+ this.state.table.filter(data => data == "sms").map((val) => { return "active" })} onClick={() => this.change("sms")} aria-current="page" to={"/sms"}>
                            <FeatherIcon icon="mail" size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">SMS</span>
                          </Link>
                        </li>
                      )
                    } */}

                    <li className="compta-sidebar__section" aria-hidden="true">Suivi</li>


                    {
                      this.handleCheck("Afficher rapport") == true && (
                        <li className="nav-item">
                          <Link title="Rapport" className={"nav-link p-2 "+ this.state.table.filter(data => data == "reports").map((val) => { return "active" })} onClick={() => this.change("reports")} aria-current="page" to={"/reports"}>
                            <FeatherIcon icon="server" size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Rapports</span>
                          </Link>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher corbeille") == true && (
                        <li className="nav-item">
                          <Link title="Corbeille" className={"nav-link p-2 "+ this.state.table.filter(data => data == "trash").map((val) => { return "active" })} onClick={() => this.change("trash")} aria-current="page" to={"/trash"}>
                            <FeatherIcon icon="trash"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Corbeille</span>
                          </Link>
                        </li>
                      )
                    }
                    {
                      this.handleCheck("Afficher archive") == true && (
                        <li className="nav-item">
                          <Link title="Archive" className={"nav-link p-2 "+ this.state.table.filter(data => data == "archives").map((val) => { return "active" })} onClick={() => this.change("archives")} aria-current="page" to={"/archives"}>
                            <FeatherIcon icon="archive"  size={"16"}></FeatherIcon>
                            <span className="ms-2 d-none d-sm-inline">Archive</span>
                          </Link>
                        </li>
                      )
                    }
                    
                      <ManualSidebarLink onSelect={() => this.change("manual")} />
                      
                      <li className="nav-item compta-sidebar__logout">
                        <Link title="Deconnexion" className="nav-link p-2 " onClick={() => this.logout()} aria-current="page" to={"#"}>
                          <FeatherIcon icon="lock" size={"16"}></FeatherIcon>
                          <span className="ms-2 d-none d-sm-inline">Déconnexion</span>
                        </Link>
                      </li>

                    </ul>
                    <hr />

                </div>
                <Modal
                  show={this.state.modal}
                  onHide={this.state.modal}
                  backdrop={"static"}>
                  <Modal.Header>
                      <Modal.Title className="h6 font-monospace">Actualisation des données</Modal.Title>
                  </Modal.Header>
                    <Modal.Body>
                        <div className="text-center font-monospace">{ this.state.isModal ? "" : <div><FeatherIcon className="user-search-spin" icon="loader" /></div>}</div>
                      </Modal.Body>
                    <Modal.Footer>
                      {
                        this.state.isModal && (
                          <button onClick={() => this.modal() } className="btn btn-outline-secondary btn-sm"><FeatherIcon icon="corner-down-left"></FeatherIcon> Fermer</button>
                        )
                      }
                    </Modal.Footer>
                </Modal>
            </div>



        )
    }
}
export default withRouter(Sidebar);
